import { LoanService, AuthService } from '@/utils/service'
import Vue from 'vue'
export const getRepaymentInfo = () => {
  return new LoanService({
    url: '/loan/app/user/v4/info/repayment',
    method: 'get'
  })
}
// 获取航班在贷
export const getRepaymentInfoForHB = () => {
  return new LoanService({
    url: '/loan/app/user/v6/hb/loan',
    method: 'get'
  })
}
export const cmbcWithdraw = () => {
  return new AuthService({
    url: '/api/app/cmbc/withdraw/url',
    method: 'get',
    data: {
      source: 'h5_wallet',
      productId: 'DM-QBXJ'
    }
  })
}
export const cmbcRechargeRepay = (params = {
  balance: 0,
  callback: '',
  projectId: 0,
  repayType: 1, // 1 提前还款  2 正常还款
  source: 'dumiao',
  dueDate: '',
  skin: '',
  app: 0,
  productId: "DM-QBXJ",
  deviceInfo: decodeURIComponent(Vue.cookie('deviceInfo') || "")
}) => {
  return new LoanService({
    url: '/loan/pmt/v1/redirect/recharge',
    method: 'get',
    data: params
  })
}
export const getRepaymentInfoByApplyId = (applyId) => {
  return new LoanService({
    url: '/loan/app/user/v4/info/currepayment',
    method: 'get',
    data: {
      applyId: applyId
    }
  })
}
export const calc = (applyId) => {
  return new LoanService({
    url: '/loan/post/lending/v1/prepayment/calc',
    method: 'get',
    data: {
      applyId: applyId
    }
  })
}

// 获取30天内待还款项目列表
export const getCurrList = (params) => {
  return new LoanService({
    url: '/loan/app/user/v6/info/currlist',
    method: 'get',
    data: params
  })
}

// 根据资方获取银行卡列表
export const getVendorCardList = (params) => {
  return new LoanService({
    url: '/loan/app/user/v6/card/list',
    method: 'get',
    data: params
  })
}

// 设置自动还款卡
export const setDefaultCard = (params) => {
  return new LoanService({
    url: '/loan/app/user/v6/default/card/set',
    method: 'post',
    data: params
  })
}

export const redirectRepayV6 = (params) => {
  return new LoanService({
    url: '/loan/app/user/v6/redirect/repay',
    method: 'get',
    data: params
  })
}